import { render, staticRenderFns } from "./client.vue?vue&type=template&id=0331e59e"
import script from "./client.vue?vue&type=script&lang=js"
export * from "./client.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports